import { Link, createFileRoute } from '@tanstack/react-router'
import { pageMeta } from '~/lib/site/seo'
import { cacheHeaders } from '~/lib/site/cache'
import { DEFAULT_FB } from '~/lib/adb/client'
import { sortedRegions } from '~/lib/adb/chapter'
import { loadRegions } from '~/lib/adb/events-loader'
import { Container } from '~/components/ui/Container'
import { PageTitle } from '~/components/ui/PageTitle'
import { pageTop } from '~/components/ui/PageHero'

const cardClass =
  'flex items-center gap-2 rounded-lg bg-surface-alt px-4 py-3.5 text-base font-bold text-accent transition-colors hover:bg-surface-alt-hover md:text-lg'

export const Route = createFileRoute('/events/chapters')({
  loader: ({ context: { queryClient } }) => loadRegions(queryClient),
  headers: () => cacheHeaders.events,
  head: () =>
    pageMeta({
      title: 'Events by Chapter',
      description:
        'Browse upcoming animal rights events for every DxE chapter.',
    }),
  component: ChaptersIndex,
})

// Crawlable index: links every chapter's event list so the static build
// prerenders all of them (and, through them, every event page).
function ChaptersIndex() {
  const regions = Route.useLoaderData()
  return (
    <div className={`${pageTop} pb-[60px]`}>
      <Container>
        <PageTitle className="mb-10">Events by chapter</PageTitle>
        {!regions && (
          <p>
            Couldn't load the chapter list right now.{' '}
            <Link
              to="/events"
              className="font-bold text-accent hover:underline"
            >
              See events near you
            </Link>
            .
          </p>
        )}
        {sortedRegions(regions ?? {}, true).map(({ region, chapters }) => (
          <section key={region}>
            <h2 className="mt-10 mb-4 text-2xl font-bold text-fg">{region}</h2>
            <div className="grid grid-cols-2 gap-4 md:grid-cols-4">
              {chapters.map((c) =>
                c.ID ? (
                  <Link
                    key={c.Name}
                    to="/events/$pageId"
                    params={{ pageId: c.ID }}
                    className={cardClass}
                  >
                    {c.Name}
                  </Link>
                ) : (
                  <a
                    key={c.Name}
                    href={`${c.FbURL || DEFAULT_FB}/events`}
                    target="_blank"
                    rel="noreferrer"
                    className={cardClass}
                  >
                    {c.Name}
                  </a>
                ),
              )}
            </div>
          </section>
        ))}
      </Container>
    </div>
  )
}
